import React from "react";

// * MeetingFormPreview is a component that displays a list of meeting details,
// * including the agenda, start time, and end time. It provides options to edit
// * each meeting and add a new meeting. If no meetings are available, it shows
// * a message indicating that no meetings are found.
const MeetingFormPreview = ({
  meetingFormDetails,
  handleEdit,
  handleSubAdd,
}) => {
  return (
    <>
      {Array.isArray(meetingFormDetails) && meetingFormDetails.length > 0 ? (
        meetingFormDetails.map((meeting, index) => (
          <div className="saved-details" key={index}>
            <p>Meeting Agenda: {meeting?.agenda}</p>
            <p>
              Start:{" "}
              {new Date(meeting?.start).toLocaleDateString("en-US", {
                day: "numeric",
                month: "short",
              })}{" "}
              -{" "}
              {new Date(meeting?.start).toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })}
            </p>
            <p>
              End:{" "}
              {new Date(meeting?.end).toLocaleDateString("en-US", {
                day: "numeric",
                month: "short",
              })}{" "}
              -{" "}
              {new Date(meeting?.end).toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })}
            </p>
            <button className="add-space" onClick={() => handleEdit(index)}>
              Edit
            </button>
          </div>
        ))
      ) : (
        <p>No meetings found</p> // Fallback in case there are no meetings
      )}
      <div className="buttons-controller">
        <button className="add-space" onClick={() => handleSubAdd()}>
          Add Another Meeting
        </button>
      </div>
    </>
  );
};

export default MeetingFormPreview;
